import { Navigate } from "react-router";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "@/lib/featureFlags";
import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeatureGrid } from "@/components/landing/FeatureGrid";
import { StatsBand } from "@/components/landing/StatsBand";
import { ScreenshotShowcase } from "@/components/landing/ScreenshotShowcase";
import { ProcessFlow } from "@/components/landing/ProcessFlow";
import { TrustSection } from "@/components/landing/TrustSection";
import { LandingCta } from "@/components/landing/LandingCta";
import { LandingFooter } from "@/components/landing/LandingFooter";

export default function Landing() {
  const { enabled, isLoading } = useFeatureFlag(
    "landing-page",
    FEATURE_FLAGS["landing-page"] ?? false,
  );

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <LandingNavbar />
      <main className="pt-16">
        <HeroSection />
        <div id="features">
          <FeatureGrid />
        </div>
        <StatsBand />
        <ScreenshotShowcase />
        <div id="process">
          <ProcessFlow />
        </div>
        <div id="security">
          <TrustSection />
        </div>
        <LandingCta />
      </main>
      <LandingFooter />
    </div>
  );
}
